import { componentRef } from './consts';

export default function (editor, opts = {}) {
  const options = opts;
  const bm = editor.BlockManager;
  const pfx = options.pfx;

  if (options.blocks.indexOf(componentRef) >= 0) {
    bm.add(componentRef, {
      label: `
      <svg xmlns="http://www.w3.org/2000/svg" height="64" width="64"><path d="M32.898 43.9c-3.92.02-7.118-3.133-7.138-7.052-.03-3.92 3.127-7.113 7.05-7.137 3.92-.03 7.116 3.127 7.143 7.046s-3.13 7.12-7.053 7.143m-20.9.133c-3.922.027-7.12-3.13-7.142-7.046-.027-3.922 3.13-7.12 7.053-7.143a7.1 7.1 0 0 1 7.141 7.046 7.1 7.1 0 0 1-7.052 7.143m20.78-19.06c-4.533.032-8.447 2.605-10.41 6.353-2.013-3.727-5.96-6.25-10.488-6.218-2.56.01-5.047.856-7.084 2.408l-.064-9.962a2.37 2.37 0 0 0-2.384-2.304 2.36 2.36 0 0 0-2.346 2.333L.118 37.2h.006a11.83 11.83 0 0 0 11.9 11.56c4.528-.03 8.443-2.603 10.413-6.354 2.008 3.725 5.962 6.248 10.49 6.22 6.533-.04 11.795-5.373 11.755-11.907S39.3 24.92 32.774 24.962m30.73 19.747l-6.642-8.06 6.536-8.144c.8-1.045.563-2.502-.56-3.27-1.134-.765-2.718-.56-3.572.457v-.004l-5.648 7.03-5.733-6.95c-.87-1.008-2.46-1.196-3.575-.414-1.12.783-1.346 2.24-.52 3.282l6.636 8.055-6.537 8.14c-.81 1.05-.564 2.503.568 3.27 1.123.77 2.712.563 3.566-.455l5.643-7.026 5.74 6.954c.867 1.01 2.456 1.193 3.58.412 1.117-.79 1.34-2.24.52-3.28" fill="#22a7f0"/></svg>
      <div class="gjs-block-label">${options.labelTable}</div>
      `,
      category: options.labelBoxFolderListCategory,
      content: `
                <div class="${pfx} box-folder-wrapper"
                data-gjs-type="${componentRef}"
                data-box-folder-component
                data-gjs-custom-name="${options.labelTable}">
                <div id="box-folder-list" class="${pfx} folder-radios mt-2">
                <label class="box-folder-label" id="box-folder-list-label">
                <input id="box-folder-list-radio" class="box-folder-radio" type="radio" name="folder" value="folder1">
                Folder 1
                </label><br>
                </div>
                <button class="box-folder-button btn btn-primary btn-sm mt-2" id="save-box-folder-selection">Save</button>
                </div>

      `,
      render: ({ model, className }) => `
        <div class="${className}-label ${className}__drapcode-wrap">
          ${model.get('label')}
        </div>
      `,
    });
  }
}
